import React from 'react';

import title from '../asset/title.png';
import apply from '../asset/apply.png';
import disabledApply from '../asset/disabledApply.png';
import share from '../asset/share.png';
import tooltip from '../asset/tooltip.png';

import {
  CommentContainer,
  ContentWrap,
  TitleWrap,
  Title,
  ApplyWrap,
  ApplyInput,
  ApplyBtnWrap,
  ApplyBtn,
  Divider,
  CommentListWrap,
  Content,
  Comment,
  UserName,
  UserComment,
  EventDescription,
  Text,
  ShareWrap,
  ShareBtn,
  ToolTipWrap,
  ToolTip,
} from './styled';

const CommentComponent = ({
  state,
  changeComment,
  submit,
  clickKaKaoShare,
}) => {
  const eventDescription = [
    '댓글 작성 시, 자동으로 응모되며, 이벤트와 무관한 글은 사전 통보없이 제거될 수 있습니다.',
  ];

  function replaceAt(origin, index, replacement) {
    if (index >= origin.length) return origin.valueOf();

    return origin.substring(0, index) + replacement + origin.substring(index + 1);
  }
  
  return (
    <CommentContainer>
      <ContentWrap>
        <TitleWrap>
          <Title imgUrl={title}/>
        </TitleWrap>
   
        <ApplyWrap>
          <ApplyInput 
            name='comment'
            value={state.comment} 
            placeholder={'예) 침구를 화사한 컬러로 바꾸기,\n꽃 향이 나는 룸 스프레이 뿌리기 등등'} 
            onChange={changeComment} 
          />

          <ApplyBtnWrap onClick={state.ableSubmit ? submit : null}>
            <ApplyBtn imgUrl={state.ableSubmit ? apply : disabledApply}/>
          </ApplyBtnWrap>
        </ApplyWrap>

        <Divider />

        <CommentListWrap>
          <Content>
            {state.commentList?.map((value, index) => (
                <Comment key={index}>
                  <UserName>
                    {/* {replaceAt(value.user, value.user?.length-1, '**')} */}
                    {value.fakeId}
                  </UserName>

                  <UserComment>
                    {value.comment}
                  </UserComment>
                </Comment>
              ))}
          </Content>    
        </CommentListWrap>

        <EventDescription>
          {eventDescription.map((text, index) => (
            <Text key={index}>
              {text}
            </Text>
          ))}
        </EventDescription>
      </ContentWrap>

      <ShareWrap onClick={clickKaKaoShare}>
        <ShareBtn imgUrl={share}/>
      </ShareWrap>
  
      <ToolTipWrap>
        <ToolTip imgUrl={tooltip}/>
      </ToolTipWrap>
    </CommentContainer>
  );
}

// const result = [
//   {
//     user:'doiu**',
//     comment:'일단 따뜻해 보이게 하는 인테리어 용품 다 정리하고, 가구 배치도 바꾸고, 심심한 벽은 포스터로 채우면 분위기가 달라지더라구요!',
//   },
//   {
//     user:'ooi**',
//     comment:'침구를 모두 얇은 소재의 아이보리톤으로 교체하면 봄 맞이 준비 끝!',
//   },
//   {
//     user:'slb902**',
//     comment:'룸스프레이의 향을 바꾸면, 봄맞이 대청소한 느낌이 나요',
//   },
//   {
//     user:'dongjuh**',
//     comment:'겨울옷 정리하고 봄옷으로 다 꺼내기',
//   },
//   {
//     user:'bhdie**',
//     comment:'커텐을 다 모아서 빨아요, 그럼 방에 좋은 향기까지 나요',
//   },
//   {
//     user:'3283**',
//     comment:'꽃향기 디퓨저 소환하면 봄맞이 방청소 완벽!',
//   },
//   {
//     user:'uniuni**',
//     comment:'청소 다 하고 창가에 다육이나 식물을 놓으면, 봄느낌나고 볼  때마다 기분이 좋아져요',
//   },
//   {
//     user:'taekho**',
//     comment:'겨울침구 정리하고 봄침구 꺼냬고 봄커텐으로 화사하게 꾸미기',
//   },
//   {
//     user:'euwa**',
//     comment:'전기장판 싹 정리해서 넣었어요. 밑에서 머리카락이 많이 나와 조금 놀랐네요 ㅎㅎ',
//   },
//   {
//     user:'makuru**',
//     comment:'겨울코드나 패딩은 드라이 맡기고 가벼운 옷으로 옷장정리 했어요!!',
//   },
// ];

export default CommentComponent;
